import React from 'react';
import { Helix2000Character } from '../../../../../shared/CharacterTypes';
import { inputStyle, labelStyle, sectionHeaderStyle } from './styles';

interface CharacterFeelProps {
  player: Helix2000Character;
  onPlayerPhysicsChange: (key: string, value: number) => void;
}

export const CharacterFeel: React.FC<CharacterFeelProps> = ({ player, onPlayerPhysicsChange }) => {
  const params = [
    { label: 'Target Jump Height', key: 'targetJumpHeight', min: 50, max: 350, step: 10 },
    { label: 'Move Speed', key: 'moveSpeed', min: 100, max: 660, step: 10 },
    { label: 'Acceleration', key: 'acceleration', min: 1000, max: 8000, step: 100 },
    { label: 'Deceleration', key: 'deceleration', min: 2000, max: 12000, step: 100 }
  ];

  return (
    <>
      <div style={sectionHeaderStyle}>Character "Feel"</div>
      {params.map(p => (
        <div key={p.key} style={{ marginBottom: '15px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
            <label style={labelStyle}>{p.label}</label>
            <input
              type="number"
              step={p.step}
              value={(player.movementStats as any)[p.key] || 0}
              style={{ ...inputStyle, width: '60px', marginBottom: 0, padding: '2px 5px', fontSize: '11px' }}
              onChange={(e) => onPlayerPhysicsChange(p.key, Number(e.target.value))}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </div>
          <input
            type="range" min={p.min} max={p.max} step={p.step}
            value={(player.movementStats as any)[p.key] || 0}
            style={{ width: '100%', margin: 0 }}
            onChange={(e) => onPlayerPhysicsChange(p.key, Number(e.target.value))}
          />
        </div>
      ))}
    </>
  );
};
